import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import { closeSession } from "../lib/Router";

const Container = styled.div`
  position: relative;
  display: flex;
`;

const IconButton = styled.svg`
  width: 24px;
  height: 24px;
  cursor: pointer;
  stroke: #ffffff;
  transition: opacity 0.2s ease;
  &:hover {
    opacity: 0.8;
  }
`;

const Menu = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  background-color: #ffffff;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  margin-top: 6px;
  z-index: 1000;
  min-width: 180px;
  overflow: hidden;
  animation: fadeIn 0.15s ease-out;

  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(-4px); }
    to { opacity: 1; transform: translateY(0); }
  }
`;

const MenuItem = styled.div`
  padding: 10px 14px;
  cursor: pointer;
  text-align: center;
  font-size: 0.95rem;
  font-weight: 500;
  color: #333;
  transition: background 0.2s;

  &:hover {
    background: #f5f5f5;
  }
`;

const DropdownLogout = ({color = "white"}) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => setOpen(!open);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setOpen(false);
    }
  };

  const onLogout = async () => {
    await closeSession();
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <Container ref={dropdownRef}>
      <IconButton
        onClick={toggleDropdown}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M14 5C14 3.9 13.1 3 12 3C10.9 3 10 3.9 10 5C10 6.1 10.9 7 12 7C13.1 7 14 6.1 14 5Z" strokeWidth="1.5" stroke={color} />
        <path d="M14 19C14 17.9 13.1 17 12 17C10.9 17 10 17.9 10 19C10 20.1 10.9 21 12 21C13.1 21 14 20.1 14 19Z" strokeWidth="1.5"  stroke={color}/>
        <path d="M14 12C14 10.9 13.1 10 12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12Z" strokeWidth="1.5"  stroke={color}/>
      </IconButton>

      {open && (
        <Menu>
          <MenuItem onClick={onLogout}>Cerrar sesión</MenuItem>
        </Menu>
      )}
    </Container>
  );
};

export default DropdownLogout;